/** @jsx React.createElement */
/** @jsxFrag React.Fragment */
import * as React from 'react';
import {Button, Typography} from 'onboarding-components';

import styles from '../index.module.styl';

export const Banner = ({title, description, actionName, action, background}) => {
  return (
    <>
      <div className={styles.banner} style={{backgroundColor: `${background}`}}>
        <div>
          <div className={styles.bannerTitle}>
            <Typography variant='bodySm' weight='bold'>
              {title}
            </Typography>
          </div>
          <div className={styles.bannerDescription}>
            <Typography variant='bodySm' weight='regular'>
              {description}
            </Typography>
          </div>
        </div>
        <div className={styles.bannerButton}>
          <Button onClick={action} variant='inline' includeArrow={false}>
            {actionName}
          </Button>
        </div>
      </div>
    </>
  );
};
